import { DashboardRouteNames, automationRouteNames, calendarRouteNames, contactsRouteNames, conversationRouteNames, customMenuLinkRouteNames, launchPadRouteNames, locationSettingsRouteNames, notificationsRouteNames, opportunitiesRouteNames, remindersRouteNames, reportingRouteNames, socialMediaRouteNames } from '@/routes/constants/location'

const routeMapping = {
    dashboard_default: DashboardRouteNames.default,
    reporting_adwords: reportingRouteNames.google,
    reporting_adwords_campaigns: 'reporting-adwords-campaigns-v2',
    reporting_adwords_adgroups: 'reporting-adwords-adgroups-v2',
    reporting_adwords_ads: 'reporting-adwords-ads-v2',
    reporting_adwords_keywords: 'reporting-adwords-keywords-v2',
    reporting_adwords_conversions: 'reporting-adwords-conversions-v2',
    reporting_facebook: reportingRouteNames.facebook,
    reporting_facebook_campaigns: 'reporting-facebook-campaigns-v2',
    reporting_facebook_adsets: 'reporting-facebook-adsets-v2',
    reporting_facebook_ads: 'reporting-facebook-ads-v2',
    reporting_facebook_demographics: 'reporting-facebook-demographics-v2',
    reporting_attribution: 'reporting-attribution-v2',
    'appointments-reports': reportingRouteNames.appointments,
    'appointments-reports-old': reportingRouteNames.appointmentsOld,
    'audit-report': reportingRouteNames.auditReport,
    call_stats: reportingRouteNames.callStats,
    agent_reporting: reportingRouteNames.agent,
    dashboard: DashboardRouteNames.default,
    location_launchpad: launchPadRouteNames.default,
    appointments: 'appointments-v2',
    [calendarRouteNames.default]: calendarRouteNames.calendarPageV2,
    conversations: conversationRouteNames.conversationsIdV2,
    reminders: remindersRouteNames.default,
    opportunities: opportunitiesRouteNames.default,
    chat_widget_settings: 'chat-widget-settings-v2',
    chat_widget: 'chat-widget',
    edit_chat_widget: 'edit-chat-widget',
    chat_widget_builder: 'chat-widget-builder',
    analysis: 'analysis-v2',
    bulk_imports_log: 'bulk-imports-log-v2',
    bulk_actions_log: contactsRouteNames.bulkActions,
    customer_bulk_actions: 'bulk-imports-log-v2',
    bulk_actions: contactsRouteNames.bulkActions,
    contacts: 'contacts-contacts-v2',
    manual_actions: conversationRouteNames.manualActions,
    customers_contact: contactsRouteNames.smartList,
    smart_list: contactsRouteNames.smartList,
    import_filter: contactsRouteNames.importFilter,
    business_name: contactsRouteNames.businessName,
    leads: 'leads-v2',
    contact_detail: contactsRouteNames.contactDetail,
    contact_restore: contactsRouteNames.contactRestore,
    social_media: socialMediaRouteNames.default,
    membership: '',
    all_funnels: 'funnels-page-v2',
    websites_funnels: 'websites-funnels-v2',
    stores_funnels: 'stores-funnels-v2',
    webinars_funnels: 'webinars-funnels-v2',
    fav_funnels: 'fav_funnels-v2',
    recent_funnels: 'recent_funnels-v2',
    archived_funnels: 'archived_funnels-v2',
    funnels_detail: 'funnels-detail-v2',
    funnel_steps: 'funnel-step-overview-v2',
    funnel_step_overview: 'funnel-step-overview-v2',
    funnel_step_automation: 'funnel-step-automation-v2',
    funnel_step_publish: 'funnel-step-publish-v2',
    funnel_step_product: 'funnel-step-product-v2',
    funnel_step_products: 'funnel-step-products-v2',
    funnel_step_product_v2: 'funnel-step-product-v2-create',
    funnel_step_product_v2_edit: 'funnel-step-product-v2-edit',
    funnel_stats: 'funnel-stats-v2',
    funnel_sales: 'funnel-sales-v2',
    funnel_security: 'funnel-security-v2',
    funnel_events: 'funnel-events-v2',
    wordpress: 'wordpress-v2',
    wordpress_dashboard: 'wordpress-v2',
    funnel_settings: 'funnel-settings-v2',
    websites_detail: 'websites-detail-v2',
    website_pages: 'website-pages-v2',
    website_stats: 'website-stats-v2',
    website_sales: 'website-sales-v2',
    website_security: 'website-security-v2',
    website_events: 'website-events-v2',
    website_settings: 'website-settings-v2',
    website_products: 'website-products-v2',
    website_step_products: 'website-step-products-v2',
    stores_detail: 'stores-detail-v2',
    store_pages: 'store-pages-v2',
    store_product_select: 'store-product-select-v2',
    store_stats: 'store-stats-v2',
    store_sales: 'store-sales-v2',
    store_security: 'store-security-v2',
    store_events: 'store-events-v2',
    store_settings: 'store-settings-v2',
    store_products: 'store-products-v2',
    store_step_products: 'store-step-products-v2',
    webinars_detail: 'webinars-detail-v2',
    webinar_pages: 'webinar-pages-v2',
    webinar_stats: 'webinar-stats-v2',
    webinar_sales: 'webinar-sales-v2',
    webinar_security: 'webinar-security-v2',
    webinar_events: 'webinar-events-v2',
    webinar_settings: 'webinar-settings-v2',
    webinar_products: 'webinar-products-v2',
    webinar_step_products: 'webinar-step-products-v2',
    funnel_templates_category: 'funnel-templates-category',
    website_templates_category: 'website-templates-category',
    store_templates_category: 'store-templates-category',
    webinar_templates_category: 'webinar-templates-category',
    funnel_templates_category_detail: 'funnel-templates-category-detail',
    website_templates_category_detail: 'website-templates-category-detail',
    store_templates_category_detail: 'store-templates-category-detail',
    webinar_templates_category_detail: 'webinar-templates-category-detail',
    funnel_templates_detail: 'funnel-templates-detail',
    website_templates_detail: 'website-templates-detail',
    store_templates_detail: 'store-templates-detail',
    webinar_templates_detail: 'webinar-templates-detail',
    triggers: automationRouteNames.triggers,
    newWorkflow: automationRouteNames.newWorkflows,
    workflows: automationRouteNames.workflows,
    triggers_detail: automationRouteNames.triggerDetail,
    customer_acquisition: automationRouteNames.campaigns,
    campaign_edit: automationRouteNames.campaignEdit,
    campaign_detail: automationRouteNames.campaignDetail,
    campaign_accounts_list: automationRouteNames.campaignAccountsList,
    campaign_activity: automationRouteNames.campaignActivity,
    bulk_requests: automationRouteNames.bulkRequests,
    links: 'triggers-links-v2',
    form_builder: 'form-builder-main-v2',
    form_builder_main: 'form-builder-main-v2',
    form_builder_analyze: 'form-builder-analyze-v2',
    form_builder_submissions: 'form-builder-submissions-v2',
    quiz_builder: 'quiz-builder-main',
    quiz_builder_main: 'quiz-builder-main',
    quiz_builder_submissions: 'quiz-builder-submissions-v2',
    email_builder_list: 'email_builder_list-v2',
    email_builder_dashboard: 'email_builder_dashboard-v2',
    emails_home: 'emails_home-v2',
    brand_boards:'brand-boards',
    brand_boards_builder:'brand-boards-builder',
    brand_voice_builder: 'brand-voice-builder',
    default_emails: 'default-emails',
    'social-planner': 'social-planner-v2',
    form_builder_manage: 'form-builder-manage',
    form_builder_manage_v2: 'form-builder-manage-v2',
    survey_builder_manage_v2: 'survey-builder-manage-v2',
    form_builder_manage_old: 'form_builder_manage_old-v2',
    form_builder_integrate: 'form_builder_integrate-v2',
    survey_builder: 'survey-builder-main-v2',
    survey_builder_main: 'survey-builder-main-v2',
    survey_builder_analyze: 'survey-builder-analyze-v2',
    survey_builder_submissions: 'survey-builder-submissions-v2',
    survey_manage: 'survey-manage',
    survey_integrate: 'survey_integrate-v2',
    text_templates: 'conversations-sms-templates-v2',
    jotbox_form: 'jotbox_form-v2',
    jotbox_survey: 'jotbox_survey-v2',
    notifications: notificationsRouteNames.default,
    notificationslist: notificationsRouteNames.list,
    location_custom_menu_link: customMenuLinkRouteNames.default,
    facebook_page_select: '',
    google_location_select: '',
    dr_chrono_office_select: '',
    settings: 'profile-v2',
    profile: 'profile-v2',
    company_settings: locationSettingsRouteNames.company,
    location_billing: locationSettingsRouteNames.locationBilling.billingV2,
    location_wallet_transactions: locationSettingsRouteNames.locationBilling.transactions,
    no_show_sms_settings: 'no_show_sms_settings-v2',
    birthday_sms_settings: 'birthday_sms_settings-v2',
    integrations_settings: locationSettingsRouteNames.integrations.list,
    social_posting: 'social_posting-v2',
    pipeline_settings: locationSettingsRouteNames.pipeline,
    payment_settings: 'payment_settings',
    chat_widget: 'chat_widget-v2',
    appointment_widget: 'appointment-widget-2',
    phone_number: locationSettingsRouteNames.phoneNumber,
    template_settings: 'template-settings-v2',
    location_team_management: locationSettingsRouteNames.staff.team,
    location_teams_management: locationSettingsRouteNames.staff.teams,
    custom_fields_settings: locationSettingsRouteNames.fields,
    custom_values_settings: locationSettingsRouteNames.customValues,
    custom_emails_settings: locationSettingsRouteNames.customEmails,
    calendar_settings: 'calendar-settings-v2',
    automation_settings: 'automation-settings-v2',
    loc_mail_gun_settings: 'loc_mail_gun_settings-v2',
    facebook_settings: locationSettingsRouteNames.integrations.facebook,
    tiktok_settings: locationSettingsRouteNames.integrations.tiktok,
    domain_settings: locationSettingsRouteNames.domain,
    scoring: locationSettingsRouteNames.scoring,
    tags_settings: locationSettingsRouteNames.tags,
    smtp_service: locationSettingsRouteNames.emailService.default,
    eliza_faq: 'eliza-faq-v2',
    'product-create': 'product-create-v2',
    'import-stripe-product': 'import-stripe-product-v2',
    'product-details': 'product-details-v2',
    'product-edit': 'product-edit-v2',
    'product-list': 'product-list-v2',
    transactions: 'transactions-v2',
    'payment-integrations': 'payment-integrations-v2',
    'payment-integrations-callback': 'payment-integrations-callback-v2',
    website_step_product_v2: 'website-step-product-v2',
    website_step_product_v2_edit: 'website-step-product-v2-edit',
    store_step_product_v2: 'store-step-product-v2',
    store_step_product_v2_edit: 'store-step-product-v2-edit',
    webinars_step_product_v2: 'webinars-step-product-v2',
    webinars_step_product_v2_edit: 'webinars-step-product-v2-edit',
    'audit-location': locationSettingsRouteNames.auditLogs,
    template_library_admin: 'template-library-admin'
}

export default routeMapping;
